module.exports = __webpack_public_path__ + "static/media/background.4b582718.png";